import { createFileRoute } from '@tanstack/react-router';
import { SourcesPage } from '@/components/finance/sources';

// FSU shell unification: sources absorbed under the Settings sub-nav.
export const Route = createFileRoute('/admin/finance/settings/sources')({
  component: SourcesPage,
});
